import { render, staticRenderFns } from "./importContestantRound.vue?vue&type=template&id=4bb1bad3&scoped=true&"
import script from "./importContestantRound.vue?vue&type=script&lang=js&"
export * from "./importContestantRound.vue?vue&type=script&lang=js&"
import style0 from "./importContestantRound.vue?vue&type=style&index=0&id=4bb1bad3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb1bad3",
  null
  
)

export default component.exports